export default __webpack_public_path__ + "static/media/mShoes_1_p1.2e0ad7f0.jpeg";